import { render, staticRenderFns } from "./SurfaceDamagesInput.vue?vue&type=template&id=6d4b0e4c&scoped=true"
import script from "./SurfaceDamagesInput.vue?vue&type=script&lang=ts"
export * from "./SurfaceDamagesInput.vue?vue&type=script&lang=ts"
import style0 from "./SurfaceDamagesInput.vue?vue&type=style&index=0&id=6d4b0e4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b0e4c",
  null
  
)

export default component.exports